module.exports = __webpack_public_path__ + "static/img/aux_archers2.a7387c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/aux_archers2.png
// module id = a9ip
// module chunks = 0